import { render } from "./UnknownPanel.vue?vue&type=template&id=3c6f3518&scoped=true"
import script from "./UnknownPanel.vue?vue&type=script&lang=js"
export * from "./UnknownPanel.vue?vue&type=script&lang=js"

import "./UnknownPanel.vue?vue&type=style&index=0&id=3c6f3518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6f3518"]])

export default __exports__